import React from 'react'
import { Link } from 'react-router-dom'
import Blog1 from "../../assets/img/servicios/1.jpg"
import Blog2 from "../../assets/img/servicios/2.jpg"
import Blog3 from "../../assets/img/servicios/3.jpg"

function Latest() {
    //comment
  return (
    <>
        <section id="blog" className="blog-area p-relative fix pt-90 pb-90">
                <div className="container">
                    <div className="row align-items-center"> 
                        <div className="col-lg-12">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                 <h5>Hotel La Finca</h5>
                                <h2>
                                Servicios y Amenidades
                                </h2>
                                <p>A través de nuestra conexión con la Hacienda Zotoluca y la riqueza de la altiplanicie pulquera, nos posicionamos como un destino único en Hidalgo.</p>
                            </div>                           
                        </div>
                    </div>
                    <div className="row">
                        
                    <div className="col-lg-4 col-md-6">
                            <div className="single-post2 mb-30 hover-zoomin wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <Link to="/service-details"><img src={Blog3} alt="img"/></Link>
                                </div>
                                <div className="blog-content2">                                    
                                    <h4><Link to="/service-details">Amenidades</Link></h4> 
                                    <p>Estacionamiento, Free WiFi, TV por Cable, Centro de Negocios y más.</p>
                                    <div className="blog-btn"><Link to="/service-details">Ver Más</Link></div>
                                </div>
                            </div>
                        </div>
                         <div className="col-lg-4 col-md-6">
                            <div className="single-post2 mb-30 hover-zoomin wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <Link to="/service-details"><img src={Blog2} alt="img"/></Link>
                                </div>
                                <div className="blog-content2">                                    

                                    <h4><Link to="/service-details">Experiencias en la Hacienda Zotoluca</Link></h4> 
                                    <p>Vuelo en globo aerostático, paseos a caballo, degustación de pulque y más.</p>
                                    <div className="blog-btn"><Link to="/service-details">Ver Más</Link></div>
                                </div>
                            </div>
                        </div>
                       
                        <div className="col-lg-4 col-md-6">
                            <div className="single-post2 hover-zoomin mb-30 wow fadeInUp animated" data-animation="fadeInUp" data-delay=".4s">
                                <div className="blog-thumb2">
                                    <Link to="/service-details"><img src={Blog1} alt="img"/></Link>
                                </div>                    
                                <div className="blog-content2">   
                                    <h4><Link to="/service-details">Eventos Privados</Link></h4> 
                                    <p>Bodas, reuniones corporativas, celebraciones y ocasiones especiales.</p>
                                    <div className="blog-btn"><Link to="/service-details">Ver Más</Link></div>
                                     
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </section>
    </>
  )
}

export default Latest